import React from 'react'
import clsx from 'clsx'

import Dropdown from '../../../../app/components/dropdown/Dropdown'
import { LanguageOptions } from '../../../../app/constants'
import useIsOrderRoute from '../../../../app/hooks/useIsOrderRoute'
import useChangeLanguage from '../../../../app/hooks/useChangeLanguage'

import styles from './NavLanguageSwitcher.module.scss'

export default function NavLanguageSwitcher() {
  const isOrderRoute = useIsOrderRoute()

  const { language, changeLanguage } = useChangeLanguage()

  return (
    <div
      className={clsx(styles.localeSwitchContainer, {
        [styles.isOrderPage]: isOrderRoute,
      })}
    >
      {isOrderRoute && <div className={styles.divider} />}
      <Dropdown
        label={language}
        buttonClassName={styles.localeSwitchButton}
        popupClassName={styles.localSwitchDropdown}
        labelClassName={styles.localeSwitchLabel}
        popupPlacement="top-end"
        onClickOption={changeLanguage}
        options={LanguageOptions}
      />
    </div>
  )
}
